import { StateType } from '../../../../states';
import { type Selector } from '../../../../types/selectors';
import { GRGlobalState } from '../../reducers/gr';
import { GRGlobalStatuses, GRSkinId, GRSkinIds } from '../../types/global';
import { selectGRState } from '../gr/grPrimary.selector';

const emptyObj = {};

export const selectGRGlobalState: Selector<GRGlobalState> = (state: StateType) =>
  selectGRState(state)?.global ?? emptyObj;

export const selectGRGlobalVersion: Selector<string | null | void> = (state: StateType) =>
  selectGRGlobalState(state)?.version;

export const selectGRGlobalStatus = (state: StateType) => selectGRGlobalState(state)?.status ?? GRGlobalStatuses.ENDING;

export const selectGRGlobalEligibility: Selector<unknown> = (state: StateType) =>
  selectGRGlobalState(state)?.eligibility || emptyObj;

export const selectGRGlobalRaceId: Selector<string | undefined> = (state: StateType) =>
  selectGRGlobalState(state)?.race;

export const selectGRGlobalSkinId = (state: StateType): GRSkinId =>
  selectGRGlobalState(state)?.skinId ?? GRSkinIds.GIFT_RACE;

export const selectGRGlobalStartDate: Selector<number | undefined> = (state: StateType) =>
  selectGRGlobalState(state)?.operationStartDate;

export const selectGRGlobalEndDate: Selector<number | undefined> = (state: StateType) =>
  selectGRGlobalState(state)?.operationEndDate;
